<template>
  <b-card style="position: relative">
    <div v-if="$store.getters['fieldServices.installation.form/isLoading']" class="loading_page">
      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
    </div>

    <b-form @submit.prevent="()=> $store.dispatch('fieldServices.installation.form/create')">
      <b-row>
        <b-col cols="12">
          <installation-form />
        </b-col>
        <b-col cols="12">
          <b-button 
            v-ripple.400="'rgba(255, 255, 255, 0.15)'" 
            type="submit" 
            variant="primary" 
            class="mr-1"
          >
            {{ $t('Save') }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>

import { OrbitSpinner } from 'epic-spinners'

import { 
  BButton, 
  BCard, 
  BCol, 
  BForm, 
  BFormGroup, 
  BFormInput,
  BInputGroup, 
  BRow, 
  BAlert, 
  BTabs, 
  BTab, 
  BCardText
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import InstallationForm from '@/views/modules/fieldServices/installation/components/Form'
import StoreModule from '@/app/fieldServices/installation/FormStoreModule.js'

export default {
  name: 'create',
  components: {
    InstallationForm,
    BRow,
    BCard,
    BCol,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner
  },
  directives: {
    Ripple
  },
  setup( props, { root }) {

    const STORE_MODULE = 'fieldServices.installation.form'
    store.registerModule(STORE_MODULE, StoreModule)

    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE)){
        store.unregisterModule(STORE_MODULE)
      }
    })

    store.commit('fieldServices.installation.form/updateRoot', root)

    return {}

  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}

</style>
